import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

/**
 * Note: Went for a plural name, because FileList is a DOM type.
 */ const FilesList = ({ items , className  })=>{
    /**
   * No reason to return a <ul> if there are no items to be rendered.
   */ if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", {
        className: classnames('files-list', className)
    }, items.map((item, index)=>/*#__PURE__*/ React.createElement("li", {
            className: "files-list__item",
            key: `${item}-${index}`
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "paperclip",
            width: 16,
            height: 16,
            className: "files-list__item-icon"
        }), /*#__PURE__*/ React.createElement(Text, {
            variant: "caption",
            className: "files-list__item-text"
        }, item))
    ));
};

export { FilesList };
//# sourceMappingURL=FilesList.js.map
